import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LoginService } from '../login/login.service';

@Component({
  selector: 'app-login',
  templateUrl: './login-hvdm.component.html',
  styleUrls: ['./login-hvdm.component.css']
})
export class LoginHVDMComponent implements OnInit {
  parts: FormGroup;
  errorLogin: boolean;

  constructor(
    private router: Router,
    private loginService: LoginService,
    fb: FormBuilder
  ) { 
    this.parts = fb.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
    });
  }

  ngOnInit(): void {
  }

  public doLogin() {
    if (this.parts.valid) {
      const {username, password} = this.parts.value;
      this.loginService.doLogin(username, password).subscribe(
        response => this.loginSuccess(response),
        fail => this.loginFail(fail)
      );
    }
  }

  public hasError(property: string, validation: string) {
    if (this.parts && this.parts.controls[property]) {
      return this.parts.controls[property].hasError(validation);
    }
  }

  public isDirty(property: string) {
    if (this.parts && this.parts.controls[property]) {
      return this.parts.controls[property].dirty;
    }
  }

  public isTouched(property: string) {
    if (this.parts && this.parts.controls[property]) {
      return this.parts.controls[property].touched;
    }
  }

  private loginSuccess(response) {
    this.loginService.authSuccess(response);
    this.router.navigate(['hvdm/home']);
  }

  private loginFail(fail) {
    this.errorLogin = true;
    console.log(fail);
  }
}
